import { render, staticRenderFns } from "./immaturityT.vue?vue&type=template&id=878437d2&"
import script from "./immaturityT.vue?vue&type=script&lang=js&"
export * from "./immaturityT.vue?vue&type=script&lang=js&"
import style0 from "./immaturityT.vue?vue&type=style&index=0&id=878437d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports